define('presentation/signup/facades/signupForCustomerFacade',[
        'businessServices/signup/signupSessionStore',
        'common/collections/collectionSorter',
        'externalDependencies/clientApi',
        'presentation/signup/presentationObjects/affiliatePresentationObject',
        'presentation/signup/presentationObjects/hubSpotContactPresentationObject',
        'presentation/signup/presentationObjects/signupForCustomerPresentationObject'
    ],
    function() {
        let _promiseFactory = null;
        let _clientApi = null;
        let _signupSessionStore = null;

        const AffiliatePresentationObjectConstructor = require('presentation/signup/presentationObjects/affiliatePresentationObject');
        const HubSpotContactPresentationObjectConstructor = require('presentation/signup/presentationObjects/hubSpotContactPresentationObject');
        const SignupForCustomerPresentationObjectConstructor = require('presentation/signup/presentationObjects/signupForCustomerPresentationObject');

        const CollectionSorterConstructor = require('common/collections/collectionSorter');
        let _collectionSorter = new CollectionSorterConstructor();

        const buildAffiliatePresentationObject = (affiliate) => {
            const affiliatePresentationObject = new AffiliatePresentationObjectConstructor();
            affiliatePresentationObject.affiliateId = affiliate.affiliateId;
            affiliatePresentationObject.affiliateCode = affiliate.affiliateCode;
            affiliatePresentationObject.affiliateName = affiliate.affiliateName;
            affiliatePresentationObject.displayName = affiliate.affiliateCode ? affiliate.affiliateName + " ( " + affiliate.affiliateCode + " )" : affiliate.affiliateName;
            return affiliatePresentationObject;
        };

        const _buildHubSpotContactPresentationObject = (contact) => {
            const hubSpotContactPresentationObject = new HubSpotContactPresentationObjectConstructor();
            hubSpotContactPresentationObject.firstName(contact.firstName);
            hubSpotContactPresentationObject.lastName(contact.lastName);
            hubSpotContactPresentationObject.email(contact.email);
            const additionalEmails = contact.additionalEmails ? contact.additionalEmails.split(", ") : [];
            additionalEmails.forEach((email) => {
                hubSpotContactPresentationObject.additionalEmails.push(email);
            });
            hubSpotContactPresentationObject.phone(contact.phone);
            return hubSpotContactPresentationObject;
        };

        const _saveAffiliateId = (affiliateId) => {
            return _promiseFactory.defer((promise) => {
                _signupSessionStore.saveAffiliateId(affiliateId)
                    .fail(promise.reject)
                    .done(promise.resolve);
            });
        };

        const _saveHubSpotContactRecordId = (hubSpotContactRecordId) => {
            return _promiseFactory.defer((promise) => {
                _signupSessionStore.saveHubSpotContactRecordId(hubSpotContactRecordId)
                    .fail(promise.reject)
                    .done(promise.resolve);
            });
        };

        const _savePatLiveAccountNumber = (accountNumber) => {
            return _promiseFactory.defer((promise) => {
                _signupSessionStore.savePatLiveAccountNumber(accountNumber)
                    .fail(promise.reject)
                    .done(promise.resolve);
            });
        };

        const _loadSignupSession = () => {
            return _promiseFactory.defer((promise) => {
                _signupSessionStore.getState()
                    .fail(promise.reject)
                    .done((signupSession) => {
                        let signupForCustomerPresentationObject = new SignupForCustomerPresentationObjectConstructor();
                        signupForCustomerPresentationObject.affiliateId = signupSession.signupDocument.affiliateId;
                        signupForCustomerPresentationObject.hubSpotContactRecordId = signupSession.signupDocument.hubSpotContactRecordId;
                        signupForCustomerPresentationObject.patLiveAccountNumber = signupSession.signupDocument.patLiveAccountNumber;
                        promise.resolve(signupForCustomerPresentationObject);
                    });
            });
        };

        const _getAffiliates = () => {
            return _promiseFactory.defer((promise) => {
                _signupSessionStore.getAffiliates()
                    .done((result) => {
                        const affiliates = result.affiliates || [];
                        let displayAffiliates = affiliates.map((affiliate) =>  buildAffiliatePresentationObject(affiliate));
                        _collectionSorter.multiSort(displayAffiliates, ["displayName"], [true]);
                        promise.resolve(displayAffiliates);
                    });
            });
        };

        const _getHubSpotContact = (hubSpotContactRecordId) => {
            return _promiseFactory.defer((promise) => {
                _signupSessionStore.getHubSpotContact(hubSpotContactRecordId)
                    .fail(promise.reject)
                    .done((result => {
                        if (result.hubSpotContact) {
                            let hubSpotContactPresentationObject = _buildHubSpotContactPresentationObject(result.hubSpotContact);
                            promise.resolve(hubSpotContactPresentationObject);
                        } else {
                            promise.resolve(null);
                        }
                    }));
            });
        };

        const _init = (promiseFactory) => {
            _promiseFactory = promiseFactory;

            const ClientApiConstructor = require('externalDependencies/clientApi');
            _clientApi = new ClientApiConstructor();
            _clientApi.init();

            const SignupSessionStoreConstructor = require('businessServices/signup/signupSessionStore');
            _signupSessionStore = new SignupSessionStoreConstructor();
            _signupSessionStore.init();
        };


        return function() {
            let self = this;
            self.init = _init;

            self.getAffiliates = _getAffiliates;
            self.getHubSpotContact = _getHubSpotContact;
            self.loadSignupSession = _loadSignupSession;
            self.saveAffiliateId = _saveAffiliateId;
            self.saveHubSpotContactRecordId = _saveHubSpotContactRecordId;
            self.savePatLiveAccountNumber = _savePatLiveAccountNumber;
        };
    });

